// mjolnir.js
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
export class Input {
    constructor(element, callback, options) {
        this.element = element;
        this.callback = callback;
        this.options = options;
    }
}
//# sourceMappingURL=input.js.map